import { render, staticRenderFns } from "./searchPlayerCard.vue?vue&type=template&id=ca454ff4&scoped=true&"
import script from "./searchPlayerCard.vue?vue&type=script&lang=js&"
export * from "./searchPlayerCard.vue?vue&type=script&lang=js&"
import style0 from "./searchPlayerCard.vue?vue&type=style&index=0&id=ca454ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca454ff4",
  null
  
)

export default component.exports